import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Container, Grid, useMediaQuery } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import LogoutIcon from "@mui/icons-material/Logout";
import { useTranslation } from "react-i18next";
import { useUserAuth } from "../../context/UserAuthContext";
import NAV from "../../utils/nav.const";
import theme from "../../styles/styleTheme";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import FingerprintIcon from "@mui/icons-material/Fingerprint";

export default function Profile() {
  const { t } = useTranslation();
  const { signOut } = useUserAuth();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container maxWidth={"xl"}>
      <Grid
        container
        padding={1}
        sx={{
          background: "#fff",
          borderRadius: 4,
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
          minHeight: isSmallScreen ? "30vh" : "800px",
        }}
      >
        {isSmallScreen && (
          <Box sx={{ width: "100%" }}>
            <Box>
              <List>
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to={`/${NAV.PROFILE}/${NAV.PROFILE_OVERVIEW}`}
                    end
                    sx={{
                      "&.active": {
                        color: theme.palette.primary.main,

                        "& .MuiListItemIcon-root": {
                          color: theme.palette.primary.main,
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <AccountCircleIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("profile.profile")} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to={NAV.APPLICATIONS}
                    end
                    sx={{
                      "&.active": {
                        color: theme.palette.primary.main,
                        "& .MuiListItemIcon-root": {
                          color: theme.palette.primary.main,
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <PendingActionsIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("profile.applications")} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to={NAV.SCREENING_PROFILE}
                    end
                    sx={{
                      "&.active": {
                        color: theme.palette.primary.main,
                        "& .MuiListItemIcon-root": {
                          color: theme.palette.primary.main,
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <FingerprintIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("profile.screening_profile")} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    component={"a"}
                    href="https://m.ziezodan.app/link/c?source=gohome"
                    target="_blank"
                    sx={{
                      "&.active": {
                        color: theme.palette.primary.main,
                        "& .MuiListItemIcon-root": {
                          color: theme.palette.primary.main,
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <BuildOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("profile.repairrequest")} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    component={"a"}
                    href="https://gohome.rent/huuropzegging/"
                    target="_blank"
                    sx={{
                      "&.active": {
                        color: theme.palette.primary.main,
                        "& .MuiListItemIcon-root": {
                          color: theme.palette.primary.main,
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <EventBusyOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("profile.lease-termination")} />
                  </ListItemButton>
                </ListItem>
              </List>
              {isSmallScreen && <Divider />}
              <ListItem disablePadding>
                <ListItemButton onClick={() => signOut()}>
                  <ListItemIcon>
                    <LogoutIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("profile.logout")} />
                </ListItemButton>
              </ListItem>
              {isSmallScreen && <Divider />}
            </Box>
          </Box>
        )}
        {!isSmallScreen && (
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              borderRight: "1px solid #f0f0f0",
            }}
          >
            <Box>
              <List>
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to={`/${NAV.PROFILE}/${NAV.PROFILE_OVERVIEW}`}
                    end
                    sx={{
                      "&.active": {
                        color: theme.palette.primary.main,

                        "& .MuiListItemIcon-root": {
                          color: theme.palette.primary.main,
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <AccountCircleIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("profile.profile")} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to={NAV.APPLICATIONS}
                    end
                    sx={{
                      "&.active": {
                        color: theme.palette.primary.main,
                        "& .MuiListItemIcon-root": {
                          color: theme.palette.primary.main,
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <PendingActionsIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("profile.applications")} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to={NAV.SCREENING_PROFILE}
                    end
                    sx={{
                      "&.active": {
                        color: theme.palette.primary.main,
                        "& .MuiListItemIcon-root": {
                          color: theme.palette.primary.main,
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <FingerprintIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("profile.screening_profile")} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    component={"a"}
                    href="https://m.ziezodan.app/link/c?source=gohome"
                    target="_blank"
                    sx={{
                      "&.active": {
                        color: theme.palette.primary.main,
                        "& .MuiListItemIcon-root": {
                          color: theme.palette.primary.main,
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <BuildOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("profile.repairrequest")} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    component={"a"}
                    href="https://gohome.rent/verhuurdersverklaring/"
                    target="_blank"
                    sx={{
                      "&.active": {
                        color: theme.palette.primary.main,
                        "& .MuiListItemIcon-root": {
                          color: theme.palette.primary.main,
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <AssignmentOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("profile.landlord-statement")} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    component={"a"}
                    href="https://gohome.rent/huuropzegging/"
                    target="_blank"
                    sx={{
                      "&.active": {
                        color: theme.palette.primary.main,
                        "& .MuiListItemIcon-root": {
                          color: theme.palette.primary.main,
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <EventBusyOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("profile.lease-termination")} />
                  </ListItemButton>
                </ListItem>
              </List>
            </Box>
            <List>
              <Divider />
              <ListItem disablePadding>
                <ListItemButton onClick={() => signOut()}>
                  <ListItemIcon>
                    <LogoutIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("profile.logout")} />
                </ListItemButton>
              </ListItem>
            </List>
          </Grid>
        )}
        <Grid
          sx={{
            marginTop: isSmallScreen ? 3 : 0,
          }}
          item
          xs={12}
          md={9}
        >
          <Box component="main">
            <Outlet />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
